var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"button record-button",class:_vm.recordButtonClass,attrs:{"id":"record-button","disabled":_vm.disabled}},[_c('p',{staticClass:"heading"}),_c('p',[_c('b-icon',{attrs:{"pack":"fas","icon":"microphone"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }